import { SalesCommissionPricingModelHdrContainerModel } from '../../../../../models/aggregates/sales-commission/sales-commission-pricing-model-hdr-container.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';

@Injectable({
    providedIn: 'root'
})
export class SalesCommissionPricingModelHdrService extends BaseApiTemplateService<SalesCommissionPricingModelHdrContainerModel> {

    static readonly SALES_COMMISION_PRICING_MODEL_HDR_SUBPATH = 'sale-commission/pricing-model-hdrs/'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + SalesCommissionPricingModelHdrService.SALES_COMMISION_PRICING_MODEL_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + SalesCommissionPricingModelHdrService.SALES_COMMISION_PRICING_MODEL_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}